module.exports = __webpack_public_path__ + "img/user.a5dd2b9e.png";